import { FormikErrors, FormikTouched } from 'formik';

import { ContentPlacement, LogicOptions, PageOptions, URLOptions } from '@candu-ai/placement/types';

export const getDefaultOptionList = (values: ContentPlacement): PageOptions | undefined => {
  if (
    !values.urls?.length &&
    (!!values.denyURLs?.length || (!values.urlsLogicOperator && !values.denyURLs?.length))
  ) {
    // If we only have legacy URLs or if old placement is of type "On all pages"
    return PageOptions.EVERYWHERE;
  }
  if (!values.urls?.length && !values.urlsLogicOperator) {
    return undefined;
  }
  if (!values.urls?.length && values.urlsLogicOperator === LogicOptions.ALL) {
    return PageOptions.EVERYWHERE;
  }
  return PageOptions.MULTI_PAGE;
};

export const getUrlErrors = (
  errors: FormikErrors<ContentPlacement>,
  touched: FormikTouched<ContentPlacement>,
) => {
  if (!errors.urls?.length) {
    return '';
  }

  const operation = ((errors.urls as unknown) as ContentPlacement['urls'])?.find(
    (url) => url?.operation,
  )?.operation;

  return touched.urls || touched.urlsLogicOperator ? operation?.operand : '';
};

export const getNewOption = (
  option: PageOptions,
  placement: ContentPlacement,
): Pick<ContentPlacement, 'urls' | 'urlsLogicOperator'> | null => {
  if (!option) {
    return null;
  }
  if (option === PageOptions.EVERYWHERE) {
    return {
      urls: undefined,
      urlsLogicOperator: LogicOptions.ALL,
    };
  }

  if (option === PageOptions.MULTI_PAGE) {
    const firstURLOperand = placement.urls?.[0]?.operation?.operand || '';

    return {
      urls: [
        {
          operation: {
            operand: firstURLOperand,
            type: URLOptions.CONTAINS,
          },
          not: false,
        },
      ],
      urlsLogicOperator: LogicOptions.ANY,
    };
  }

  return null;
};
